module.exports = __webpack_public_path__ + "static/assets/37ec00f1fc595518e6f71d682cb72cb2.svg";